const selectHotel = () => {
  jQuery(document).ready(function($) {
    const handleMenuSelectHotelChange = (element) => {
      const menuSelectHotel = element;

      $(document).trigger('event_booking_hotel_code_changed', [menuSelectHotel.val()]);

      // OTHER TABS CAN LISTEN TO 'EVENT_BOOKING_HOTEL_CODE_CHANGED' EVENT OR JUST ADD SCRIPT HERE
    };

    const menuSelectHotel = $('.menu-select-hotel');
    if (menuSelectHotel.length) {
      menuSelectHotel.each(function() {
        const _this = $(this);

        handleMenuSelectHotelChange(_this);
      });
    }

    // Select hotels in mobile menu
    $(document).on('change', '.menu-select-hotel', function() {
      const _this = $(this);

      handleMenuSelectHotelChange(_this);
    });
  });
};

export default selectHotel;



// WEBPACK FOOTER //
// ./scripts/routes/modules/selectHotel.js